import { CHAT_IDENTIFIER_SEPARATOR } from '@provision/conversation-constants';
import { ConversationChatApp } from '@provision/conversation-types';

// TODO: Move this to a dedicated package
export function getChatIdentifier(appName: ConversationChatApp, id: string): string {
  return [appName, id].join(CHAT_IDENTIFIER_SEPARATOR);
}
